module.exports = __webpack_public_path__ + "static/media/cx.32b8e2ca.webp";